export default __webpack_public_path__ + "static/media/kfm_preview.2bcd8fee.jpg";